"use client";
import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { BASE_URL } from "../config/config";

const ResumeSubscribedUserContext = createContext();

export const useResumeSubscribedUsers = () => useContext(ResumeSubscribedUserContext);

export const ResumeSubscribedUserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token"); // token is required

  /* ================= FETCH RESUME SUBSCRIBED USERS ================= */
  const fetchUsers = useCallback(async () => {
    if (!token) return; // don't fetch if no token

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/resume-subscribed-users`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // send token
        },
      });

      const data = await res.json();

      if (res.ok && data.status) {
        setUsers(data.data || []);
      } else {
        console.error("Failed to fetch resume users:", data.message || data);
      }
    } catch (error) {
      console.error("Error fetching resume users:", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return (
    <ResumeSubscribedUserContext.Provider value={{ users, loading, fetchUsers }}>
      {children}
    </ResumeSubscribedUserContext.Provider>
  );
};
